import { render, staticRenderFns } from "./HowItWorksDappsCenter.vue?vue&type=template&id=6951cc8e&scoped=true"
import script from "./HowItWorksDappsCenter.vue?vue&type=script&lang=js"
export * from "./HowItWorksDappsCenter.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksDappsCenter.vue?vue&type=style&index=0&id=6951cc8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951cc8e",
  null
  
)

export default component.exports